<form [formGroup]="lobbyEditForm">
  <kendo-dialog id="serviceDialogModel" title="{{(isUserCanEditGrid ? '_Shared_ModalPopUp_Lobby_Edit_Record_Text_' : '_Shared_ModalPopUp_Lobby_View_Record_Text_') | translate }}"
    *ngIf="dialogOpened" (close)="close()" class="lobby-detail-edit-dialog">
    <kendo-dialog-messages closeTitle="{{'_General_Button_Close_Text_' | translate }}"></kendo-dialog-messages>
    <div class="psPanel">
      <div class="ps-list">
        <div class="col-md-12 requests-notes d-flex">
          <div class="requests mb-3">
            <div class="row">
              <!-- Visitor Information -->
              <div class="col-md-12">
                <!-- TODO - Add Localization -->
                <h6 class="sub-heading">{{'_Report_Lobby_Customer_Information_' | translate}}</h6>
              </div>
              <div class="col-md-12">
                <!-- Account Number -->
                <div class="input" *ngIf="lobbyConfiguration.EnableAccountNumber">
                  <label for="accountNumber">{{'_Account_Number_Field_Text_' | translate }}</label>
                  <input id="accountNumber" class="form-control" formControlName="accountNumber" type="text" maxlength="50"
                    app-filter pattern="^((?=[^<>&])[A-Za-z0-9`\s|!@?#\\$/%\[\]^_*()~={}:;+'&quot;.\-;,●])*$"
                        (keyup)="onAccountNumberKeyUp($event)" />
                  <div class="cc-validation">
                    <div
                      *ngIf="lobbyEditForm.get('accountNumber')?.value != lobbyData.accountNumber && lobbyEditForm.get('accountNumber')?.hasError('pattern')">
                      {{'_General_User_Invalid_Text_' | translate }} {{'_Account_Number_Field_Text_' | translate }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <!-- First Name -->
              <div class="col-md-3 input">
                <label for="first-name">
                  {{'_General_User_First_Name_Text_' | translate }}
                  <span tabindex="-1" class="required-field">*</span>
                </label>
                <input app-filter pattern="^((?=[^<>&])[A-Za-z0-9`\s|!@?#\\$/%\[\]^_*()~={}:;+'&quot;.\-;,])*$"
                  id="firstName" class="form-control" formControlName="firstName" type="text" maxlength="50" />
                <div class="cc-validation">
                  <div *ngIf="lobbyEditForm.get('firstName')?.hasError('required')">
                    {{'_General_User_First_Name_Required_Text_' | translate }}
                  </div>
                </div>
                <div class="cc-validation">
                  <div *ngIf="lobbyEditForm.get('firstName')?.hasError('pattern')">
                    {{'_General_User_First_Name_Invalid_Text_' | translate }}
                  </div>
                </div>
              </div>
              <!-- Last Name -->
              <div class="col-md-3 input">
                <label for="lastName">
                  {{'_General_User_Last_Name_Text_' | translate }}
                  <span tabindex="-1" class="required-field">*</span>
                </label>
                <input app-filter pattern="^((?=[^<>&])[A-Za-z0-9`\s|!@?#\\$/%\[\]^_*()~={}:;+'&quot;.\-;,])*$"
                  id="lastName" class="form-control" formControlName="lastName" type="text" maxlength="50" />
                <div class="cc-validation">
                  <div *ngIf="lobbyEditForm.get('lastName')?.hasError('required')">
                    {{'_General_User_Last_Name_Required_Text_' | translate }}
                  </div>
                </div>
                <div class="cc-validation">
                  <div *ngIf="lobbyEditForm.get('lastName')?.hasError('pattern')">
                    {{'_General_User_Last_Name_Invalid_Text_' | translate }}
                  </div>
                </div>
              </div>
              <!-- Email -->
              <div class="col-md-3 input" *ngIf="lobbyConfiguration.EnableEmailAddress">
                <label for="email">{{'_General_User_Email_Optional_Text_' | translate }}</label>
                <input input-field-on-past-filter
                  pattern="^((?=[^<>&])[A-Za-z0-9`\s|!@?#\\$/%\[\]^_*()~={}:;+'&quot;.\-;,])*$" id="email"
                  class="form-control" formControlName="email" type="email" maxlength="256" />
                <div class="cc-validation">
                  <div *ngIf="lobbyEditForm.get('email')?.hasError('pattern')">
                    {{'_General_User_Email_Invalid_Text_' | translate }}
                  </div>
                </div>
              </div>
              <!-- Phone Number -->
              <div class="col-md-3 input" *ngIf="lobbyConfiguration.EnablePhoneNumber">
                <label for="phoneNumber">{{'_General_User_Phone_Optional_Text_' | translate }}</label>
                <input id="phoneNumber" class="form-control" formControlName="phoneNumber" type="text" pattern="^[\d() -]*$"
                  maxlength="14" (keyup)="EnableReceiveTextMessageCheckBox()" app-filter />
                <div class="cc-validation">
                  <div *ngIf="lobbyEditForm.get('phoneNumber')?.hasError('pattern')">
                    {{'_General_User_Phone_Invalid_Text_' | translate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <!-- Date of Birth -->
              <div class="col-md-3 input" *ngIf="lobbyConfiguration.EnableDateOfBirth">
                <label for="dob">{{'_General_User_DOB_Optional_Text_' | translate }}</label>
                <input id="dob" class="form-control" formControlName="dateOfBirth" type="date" min="1900-01-01"
                  [max]="dateSelectionMaxLimit" />
              </div>
            </div>
             <div class="row">
              <!-- Custom Field -->
              <div class="col-md-6 custom-field" *ngIf="lobbyConfiguration.EnableCustomField">
                <label for="notes">{{'_Custom_Field_Text_' | translate }}</label>
                <div class="cc-textarea-container">
                  <div class="cc-textarea">
                    <input app-filter pattern="^((?=[^<>&])[A-Za-z0-9`\s|!@?#\\$/%\[\]^_*()~={}:;+'&quot;.\-;,])*$"
                      formControlName="customFieldValues" maxlength="250" id="customNotes" class="form-control" rows="3" />
                  </div>
                </div>
              </div>
              <!-- customerInfoNotes -->
                <div class="col-md-6 custom-field">
                <label for="notes">{{'_General_Notes_Info_Text_' | translate }}</label>
                <div class="cc-textarea-container">
                  <div class="cc-textarea">
                    <textarea app-filter pattern="^((?=[^<>&])[A-Za-z0-9`\s|!@?#\\$/%\[\]^_*()~={}:;+'&quot;.\-;,])*$"
                      maxlength="100" id="notes" class="form-control" formControlName="notes" rows="1"></textarea>
                    <div class="cc-validation">
                      <div *ngIf="lobbyEditForm.get('notes')?.hasError('pattern')"> 
                        {{'_General_Notes_Invalid_Text_' | translate }}note
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="col-md-12 requests-notes d-flex">
          <div class="requests mb-3">
            <div class="row">
              <div class="col-md-12">
                <h6 class="sub-heading">{{'_Report_Lobby_Interaction_Information_' | translate}}</h6>
              </div>
              <!-- Location -->
              <div class="col-md-3 input location">
                <!-- <label>{{'_General_Location_Text_' | translate }}</label>
                <input class="form-control" id="locationName" type="text" value="{{lobbyData.locationName}}" readonly /> -->

              <app-location-selector labelText="{{'_General_Location_Text_' | translate }}" [dispatchStateEvent]="false" 
                (onChange)="onLocationChange($event)"  id="locationName" [isDisableParentClick]="true" [selectorDisabled]="!isUserCanEditGrid"
                [selectedLocationId]="selectedLocationId" selectedLocationName="{{selectedLocationName}}" [selectableTypes]="[5]"  [isIncludeFloatLocation]="true" (keydown)="onDropdownKeydown($event)">
              </app-location-selector>
              </div>
              <!-- Added By -->
              <div class="col-md-3 input added-by">
                <label>{{'_Shared_ModalPopUp_Lobby_AddedBy_Text_' | translate }}</label>
                <input class="form-control" id="addedBy" type="text" value="{{lobbyView?.addedBy}}" readonly [disabled]="!isUserCanEditGrid"/>
              </div>
              <!-- LobbyId -->
              <div class="col-md-3 input lobbyId">
                <label>{{'_Shared_ModalPopUp_Lobby_Lobby_Id_Text_' | translate }}</label>
                <input class="form-control" id="lobbyId" type="text" value="{{lobbyData.lobbyEntryId}}" readonly [disabled]="!isUserCanEditGrid" />
              </div>
              <!-- Confirmation Number -->
              <div class="col-md-3 input confirmation-number" *ngIf="isACLicenseEnabled$ | async">
                <label>{{'_General_Confirmation_Text_' | translate }} #</label>
                <input class="form-control" id="lobbyId" type="text" value="{{(lobbyView?.confirmationNumber)}}" readonly [disabled]="!isUserCanEditGrid" />
              </div>              
            </div>
            <div class="row">
              <!-- Status -->
              <div class="col-md-3 input lobby-status">
                <label>{{'_General_Status_Text_' | translate }}</label>
                <input class="form-control" id="lobbyStatus" type="text" value="{{lobbyData.lobbyStatus}}" readonly [disabled]="!isUserCanEditGrid" />
              </div>
              <!-- Requests -->
              <div class="col-md-3 input reason-for-visit-actions">
                <label>{{'_Shared_ModalPopUp_Lobby_Requested_Items_Text_' | translate }}</label>
                <ng-multiselect-dropdown name="services" formControlName="requests" id="requestedServices" [disabled]="!isUserCanEditGrid"
                  placeholder="{{'_General_Select_Text_' | translate }}" [data]="allServices" [settings]="dropdownSettings" class="ocx-multiselect" (keydown)="onDropdownKeydown($event)">
                </ng-multiselect-dropdown>
              </div>
              <!-- Staff Requested -->
              <div class="col-md-3 dropdown">
                <label for="staffMember">{{'_General_Report_Staff_Requested_Text_' | translate }}</label>
                <select class="cc-select-dropdown form-control" id="staffMember" placeholder="_General_Select_Text_ | translate "
                  formControlName="personRequested">
                  <option [ngValue]="null">
                    {{'_General_Select_Text_' | translate }}
                  </option>
                  <option *ngFor="let staffMember of staffMembers" [ngValue]="staffMember">
                    {{ staffMember.firstName }} {{ staffMember.lastName }}
                  </option>
                </select>
              </div>
              <!-- LWA Reason -->
              <div class="col-md-3 dropdown" *ngIf="lobbyData.status == 6">
                <label for="lwaReason">{{'_Shared_ModalPopUp_Lobby_LWA_Reason_Text_' | translate }}</label>
                <select class="cc-select-dropdown form-control" id="lwaReason"
                  placeholder="_General_Select_Text_ | translate " formControlName="lwaReasonId">
                  <option *ngFor="let lwaReason of lwaReasons" [value]="lwaReason.id">{{ lwaReason.reason }}</option>
                </select>
              </div>
            </div>
            <div class="row">
              <!-- CheckIn Time -->
              <div class="col-md-3 input">
                <label for="checkInTime"> 
                  {{'_General_Report_CheckinTime_Text_' | translate }} <span tabindex="-1" class="required-field">*</span>
                </label>
                <!-- <input id="checkInTime" class="form-control" formControlName="checkInTime" type="datetime-local"
                  [min]="1900-01-01" [max]="dateSelectionMaxLimit" step="1" (blur)="onCheckInTimeBlur()"/> -->
                  <kendo-datetimepicker
                    formControlName="checkInTime"
                    format="M/d/yyyy hh:mm:ss a"
                    [max]="dateSelectionMaxLimit"
                    [steps]=" { hour: 1, minute: 1, second: 1}" 
                    [incompleteDateValidation]="true"
                    (valueChange)="onCheckInTimeChange($event)"
                    [popupSettings]="{ popupClass: 'timepicker-wrapper' }">
                    <kendo-datetimepicker-messages now="{{'_General_Now_Text_' | translate }}" today="{{'_General_Today_Text_' | translate }}" cancel="{{'_General_Button_Cancel_Text_' | translate}}" accept="{{'_General_Button_Set_Text_' | translate}}" acceptLabel="{{'_General_Set_Time_Text_' | translate}}" cancelLabel="{{'_General_Cancel_Changes_Text_' | translate}}" toggle="{{'_General_Toggle_Popup_Text_' | translate}}"></kendo-datetimepicker-messages>
                  </kendo-datetimepicker>

                <div class="cc-validation">
                  <div *ngIf="lobbyEditForm.get('checkInTime')?.touched">
                    <div *ngIf="!lobbyEditForm.get('checkInTime')?.errors?.incompleteDate && lobbyEditForm.get('checkInTime')?.errors?.required">
                      {{'_Report_Lobby_Check_In_Time_Required_Error_Msg_' | translate}}
                    </div>
                    <div *ngIf="lobbyEditForm.get('checkInTime')?.errors?.incompleteDate">
                    {{'_Report_Lobby_Invalid_Check_In_Time_Error_Msg_' | translate}}
                    </div>
                    <div *ngIf="lobbyEditForm.hasError('checkInAfterCompleted')">
                      {{'_Report_Lobby_Check_In_Time_Less_Error_Msg_' | translate}}
                    </div>
                  </div>
                  <div *ngIf="(lobbyEditForm.touched || gridModified) && lobbyEditForm.get('checkInTime')?.errors?.maxError">
                   {{'_Report_Lobby_Check_In_Time_More_Error_Msg_' | translate}}
                  </div>
                </div>
              </div>
              <!-- Completed Time -->
              <div class="col-md-3 input">
                <label for="completedTime">
                  {{'_General_Report_Completed_Time_Text_' | translate }} <span tabindex="-1" class="required-field">*</span>
                </label>
                <!-- <input id="completedTime" class="form-control" formControlName="completedTime" type="datetime-local" *ngIf="lobbyData.status != 6"
                  [min]="1900-01-01" [max]="dateSelectionMaxLimit" step="1" (blur)="onCompletedTimeBlur()"/> -->

                  <kendo-datetimepicker
                    formControlName="completedTime"
                    format="M/d/yyyy hh:mm:ss a"
                    [max]="dateSelectionMaxLimit"
                    [steps]=" { hour: 1, minute: 1, second: 1}" 
                    [incompleteDateValidation]="true"
                    (valueChange)="onCompletedTimeChange($event)"
                    *ngIf="lobbyData.status !== 6"
                    [popupSettings]="{ popupClass: 'timepicker-wrapper' }">
                    <kendo-datetimepicker-messages now="{{'_General_Now_Text_' | translate }}" today="{{'_General_Today_Text_' | translate }}" cancel="{{'_General_Button_Cancel_Text_' | translate}}" accept="{{'_General_Button_Set_Text_' | translate}}" acceptLabel="{{'_General_Set_Time_Text_' | translate}}" cancelLabel="{{'_General_Cancel_Changes_Text_' | translate}}" toggle="{{'_General_Toggle_Popup_Text_' | translate}}"></kendo-datetimepicker-messages>
                  </kendo-datetimepicker>
                  <div class="cc-validation">
                    <div *ngIf="lobbyEditForm.get('completedTime')?.touched">
                      <div *ngIf="!lobbyEditForm.get('completedTime')?.errors?.incompleteDate && lobbyEditForm.get('completedTime')?.errors?.required">
                        {{'_Report_Lobby_Completed_Time_Required_Error_Msg_' | translate }}
                      </div>
                      <div *ngIf="lobbyEditForm.get('completedTime')?.errors?.incompleteDate">
                        {{'_Report_Lobby_Invalid_Completed_Time_Error_Msg_' | translate }}
                      </div>
                      <div *ngIf="lobbyEditForm.hasError('checkInAfterCompleted')">
                        {{'_Report_Lobby_Completed_Time_Greater_Than_Error_Msg_' | translate }}
                      </div>
                    </div>
                    <div *ngIf="(lobbyEditForm.touched || gridModified) && lobbyEditForm.get('completedTime')?.errors?.maxError">
                      {{'_Report_Lobby_Completed_Time_Future_Error_Msg_' | translate }}
                    </div>
                  </div>
                <input id="completedTimeText" class="form-control" type="text" *ngIf="lobbyData.status == 6"/>
              </div>
              <!-- Notes -->
              <div class="col-md-6 input">
                <label for="notes">{{'_Lobby_Wrap_Up_Comment_Text_' | translate }}</label>
                <div class="cc-textarea-container">
                  <div class="cc-textarea">
                    <textarea app-filter pattern="^((?=[^<>&])[A-Za-z0-9`\s|!@?#\\$/%\[\]^_*()~={}:;+'&quot;.\-;,])*$"
                      maxlength="500" id="notes" class="form-control" formControlName="notes" rows="1"></textarea>
                    <div class="cc-validation">
                      <div *ngIf="lobbyEditForm.get('notes')?.hasError('pattern')">
                        {{'_General_Notes_Invalid_Text_' | translate }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12 requests-notes d-flex">
        <div class="requests mb-3">
          <div class="row">
            <div class="col-md-12 mb-3 title-with-btn d-flex justify-content-between align-items-center">
              <h6 class="sub-heading mb-0">{{'_Shared_ModalPopUp_Lobby_PS_Provided_Text_' | translate }}</h6>
                <!-- Add Product/Service Button-->
              <button type="button" class="btn btn-primary" [disabled] ="(this.lobbyView?.servicesProvided?.length ?? 0) >= 10 || !isUserCanEditGrid"
                  (click)="addProduct()" >{{'_Product_Services_Add_PS_Ts_Text_' | translate }}</button>          
            </div>
            
            <div class="col-md-12 reason-for-visit-actions lobby-record-edit-reasons">
              <kendo-grid [kendoGridBinding]="this.lobbyView?.servicesProvided || []"  [group]="group" [sortable]="false" [groupable]="false" 
              class="lobby-interactions-grid" scrollable="none" [navigable]="true" (add)="addCommand($event)" (edit)="editCommand($event)"
                (remove)="removeCommand($event)" >
               <kendo-grid-messages pagerFirstPage="{{'_Go_To_First_Page_Text_' | translate}}" pagerLastPage="{{'_Go_To_Last_Page_Text_' | translate}}" pagerNextPage="{{'_Go_To_Next_Page_Text_' | translate}}" pagerPreviousPage="{{'_Go_To_Previous_Page_Text_' | translate}}" pagerPage="{{'_Page_Grid_Text_' | translate}}" noRecords="{{'_NoRecords_Grid_Text_' | translate}}" pagerItems="{{'_General_Kendo_Grid_Pageable_Items_Text_' | translate}}" pagerOf="{{'_General_Kendo_Grid_Pageable_Of_Text_' | translate}}"></kendo-grid-messages>

                  
               <kendo-grid-column field="groupIndex" [width]="0" [hidden]="true" class="test1">
                  <ng-template kendoGridGroupHeaderTemplate let-group="group" let-value="value">
                      <label class="interaction-title">{{'_Lobby_Wrap_Up_Interaction_Text_' | translate}}: {{group.items[0]?.groupIndex }}</label>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column > 
                  <ng-template kendoGridHeaderTemplate>
                    {{ '_General_Report_Product/Service_Text_' | translate }}
                    <span class="required-field">*</span>
                  </ng-template>
                  <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <select class="cc-select-dropdown form-control" [(ngModel)]="dataItem.serviceId"
                      [ngModelOptions]="{standalone: true}" (change)="onProductServiceChange(dataItem,rowIndex)"
                      (blur)="validateField(dataItem, 'serviceId')" [disabled]="!isUserCanEditGrid"
                      >
                      <option *ngFor="let service of dataItem.allServices" [ngValue]="service.id">
                        {{service.name}} 
                      </option>
                    </select>
                  </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="{{'_General_Category_Text_' | translate }}" field="category">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      {{dataItem.serviceCategoryName}}
                    </ng-template>
                </kendo-grid-column>   
                <kendo-grid-column title="{{'_Shared_ModalPopUp_Lobby_Reference_Text_' | translate }} #" >
                  <ng-template kendoGridCellTemplate let-dataItem>
                    <input type="text" class="form-control" [(ngModel)]="dataItem.referenceNumber"
                      [ngModelOptions]="{standalone: true}" [disabled]="!isUserCanEditGrid" />
                  </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="assistedBy" >
                  <ng-template kendoGridHeaderTemplate>
                    {{'_General_Report_AssistedBy_Text_' | translate }}
                    <span class="required-field">*</span>
                  </ng-template>
                  <ng-template kendoGridCellTemplate let-dataItem>
                    <select class="cc-select-dropdown form-control" *ngIf="allUsersForProductService?.length" [(ngModel)]="dataItem.assistedBy.userId"
                      [ngModelOptions]="{standalone: true}" (change)="onAssistedByChange(dataItem)"
                      (blur)="validateField(dataItem, 'assistedBy')" [disabled]="!isUserCanEditGrid">
                      <option *ngIf="dataItem.assistedBy?.userId && !isUserInSelectableList(dataItem.assistedBy.userId)"
                              [value]="dataItem.assistedBy.userId" disabled>
                        {{dataItem.assistedBy.firstName}} {{dataItem.assistedBy.lastName}}
                      </option>
                      <option *ngFor="let staffMember of allUsersForProductService" [value]="staffMember.userId">
                        {{staffMember.firstName}} {{staffMember.lastName}}  
                      </option>
                    </select>
                  </ng-template>
                  <ng-template kendoGridFooterTemplate let-dataItem>
                    <div class="service-provided-footer-total">{{'_General_Total_Text_' | translate }}:</div>
                  </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="startAssistTime" [width]="125">
                  <ng-template kendoGridHeaderTemplate>
                    {{'_Shared_ModalPopUp_Lobby_Assist_Started_Text_' | translate }}
                    <span class="required-field">*</span>
                  </ng-template>
                  <ng-template kendoGridCellTemplate let-dataItem>
                    <kendo-dateinput [(ngModel)]="dataItem.serviceStartedTime" [ngModelOptions]="{standalone: true}" format="hh:mm:ss a"
                    [max]="dateSelectionMaxLimit"  [steps]=" { hour: 1, minute: 1, second: 1}"  [incompleteDateValidation]="true"
                    (blur)="validateField(dataItem, 'serviceStartedTime')" [disabled]="!isUserCanEditGrid">
                    </kendo-dateinput>
                    <!-- {{dataItem.serviceStartTime | date: 'h:mm:ss a'}} -->
                  </ng-template> 
                </kendo-grid-column>
                <kendo-grid-column field="waitTime">
                  <ng-template kendoGridHeaderTemplate>
                    {{'_General_Report_Wait_Time_Text_' | translate }}
                    <span class="required-field">*</span>
                  </ng-template>
                  <ng-template kendoGridCellTemplate let-dataItem>
                    <kendo-maskedtextbox  #maskedBoxRef [(ngModel)]="dataItem.waitTime"  [ngModelOptions]="{ standalone: true }" mask="00:00:00"
                        promptChar="_" (blur)="onMaskedBlur(dataItem, maskedBoxRef)" [disabled]="!isUserCanEditGrid">
                    </kendo-maskedtextbox>
                  </ng-template>
                  <ng-template kendoGridFooterTemplate let-dataItem>
                    {{this.lobbyView?.waitTime}}
                  </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="serviceTime">
                  <ng-template kendoGridHeaderTemplate>
                    {{'_General_Report_Assist_Time_Text_' | translate }}
                    <span class="required-field">*</span>
                  </ng-template>
                  <ng-template kendoGridCellTemplate let-dataItem>
                    <kendo-maskedtextbox [(ngModel)]="dataItem.serviceTime"  [ngModelOptions]="{ standalone: true }" mask="00:00:00"
                        promptChar="_" (blur)="validateField(dataItem, 'serviceTime')" [disabled]="!isUserCanEditGrid" >
                    </kendo-maskedtextbox>
                  </ng-template>
                  <ng-template kendoGridFooterTemplate let-dataItem>
                    {{this.lobbyView?.serviceTime}}
                  </ng-template>
                </kendo-grid-column>
                <kendo-grid-column  field="wrapUpTime" [width]="20">
                  <ng-template kendoGridHeaderTemplate>
                    {{'_General_Report_WrapUpTime_Text_' | translate }}
                    <span class="required-field">*</span>
                  </ng-template>
                  <ng-template kendoGridCellTemplate let-dataItem>
                    <kendo-maskedtextbox [(ngModel)]="dataItem.wrapUpTime"  [ngModelOptions]="{ standalone: true }" mask="00:00:00"
                        promptChar="_" (blur)="validateField(dataItem, 'wrapUpTime')" [disabled]="!isUserCanEditGrid" >
                    </kendo-maskedtextbox>
                  </ng-template>
                  <ng-template kendoGridFooterTemplate let-dataItem>
                    {{this.lobbyView?.wrapUpTime}}
                  </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="{{'_General_Report_Interaction_Time_Text_' | translate }}" field="totalTime" [width]="20">
                  <ng-template kendoGridCellTemplate let-dataItem>
                    <!-- <input type="text" class="form-control" [(ngModel)]="dataItem.totalTime" [ngModelOptions]="{standalone: true}" /> -->
                    {{dataItem.totalTime}}
                  </ng-template>
                  <!-- <ng-template kendoGridFooterTemplate let-dataItem>
                    {{this.lobbyView?.totalTime}}
                  </ng-template> -->
                </kendo-grid-column>
                <kendo-grid-column title="{{'_General_Button_Action_Text_' | translate }}" field="deleteProduct" >
                  <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <button kendoGridRemoveCommand (click)="openProductDelete(rowIndex)"
                      class="cc-icon-btn delete" title="{{'_General_Button_Delete_Text_' | translate }}"  [disabled]="(lobbyView?.servicesProvided?.length ?? 0) === 1 || !isUserCanEditGrid" >
                      <span class="fas fa-trash-alt" ></span> 
                    </button>
                  </ng-template>
                </kendo-grid-column>

              </kendo-grid>
            </div>

            <div *ngFor="let item of lobbyView?.servicesProvided; let i = index">
              <div *ngIf="item.errors && i === topMostErrorRowIndex" class="cc-validation mb-2">
                <div *ngIf="item.errors.serviceId">{{ item.errors.serviceId }}</div>
                <div *ngIf="!item.errors.serviceId && item.errors.assistedBy">{{ item.errors.assistedBy }}</div>
                <div *ngIf="!item.errors.serviceId && !item.errors.assistedBy && item.errors.serviceStartedTime">{{ item.errors.serviceStartedTime }}</div>
                <div *ngIf="!item.errors.serviceId && !item.errors.assistedBy && !item.errors.serviceStartedTime && item.errors.waitTime">{{ item.errors.waitTime }}</div>
                <div *ngIf="!item.errors.serviceId && !item.errors.assistedBy && !item.errors.serviceStartedTime && !item.errors.waitTime && item.errors.serviceTime">{{ item.errors.serviceTime }}</div>
                <div *ngIf="!item.errors.serviceId && !item.errors.assistedBy && !item.errors.serviceStartedTime && !item.errors.waitTime && !item.errors.serviceTime && item.errors.wrapUpTime">{{ item.errors.wrapUpTime }}</div>
                <div *ngIf="item.errors.assistStartedError">{{ item.errors.assistStartedError }}</div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="col-md-12 requests-notes d-flex">
        <div class="edit-reason">
          <div class="row">
            <div class="col-md-12">
              <label for="edit Reason">
                {{'_Shared_ModalPopUp_Lobby_Edit_Reason_Text_' | translate }}
                <span tabindex="-1" class="required-field">*</span>
              </label>
              <textarea id="editReason" class="form-control" formControlName="editReason" app-filter
                pattern="^((?=[^<>&])[A-Za-z0-9`\s|!@?#\\$/%\[\]^_*()~={}:;+'&quot;.\-;,])*$" rows="1" cols="60"
                maxlength="255"></textarea>
              <div class="cc-validation">
                <div *ngIf="lobbyEditForm.get('editReason')?.touched && lobbyEditForm.get('editReason')?.hasError('required')">
                  {{'_Shared_ModalPopUp_Lobby_Edit_Reason_Required_Text_' | translate }}
                </div>
              </div>
              <div class="cc-validation">
                <div *ngIf="lobbyEditForm.get('editReason')?.hasError('pattern')">
                  {{'_Shared_ModalPopUp_Lobby_Edit_Reason_Invalid_Text_' | translate }}
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <kendo-dialog-actions class="cc-btn-panel">
      <button class="btn btn-secondary" (click)="close()">{{'_General_Button_Cancel_Text_' | translate }}</button>
      <button class="btn btn-primary"
        *ngIf="isUserCanEditGrid"
        [disabled]="!this.lobbyEditForm.dirty || !this.lobbyEditForm.valid || !isProductServiceFormValid() "
        (click)="saveLobbyEntry(lobbyEditForm.value)">
        {{'_General_Button_Save_Text_' | translate }}
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
</form>
